import { render, staticRenderFns } from "./ServicePackageEdit.vue?vue&type=template&id=47b08d8c&"
import script from "./ServicePackageEdit.vue?vue&type=script&lang=js&"
export * from "./ServicePackageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports